export default {
  all_categories: 'Toutes les catégories',
  navigation: {
    anchors: {
      about: {
        community: 'dans-la-communaute',
        'directors-board': 'conseil-dadministration',
        intro: 'qui-sommes-nous',
        'our-purpose': 'notre-raison-detre',
        overview: 'sommaire',
        products: 'lignes-de-produits',
      },
      careers: {
        benefits: 'avantages',
        culture: 'notre-culture',
        intro: 'qui-nous-sommes',
        jobs: 'emplois-en-haute-demande',
        overview: 'sommaire',
        values: 'nos-valeurs',
      },
      products: {
        intro: 'ce-que-nous-faisons',
        overview: 'sommaire',
        products: 'gamme-de-produits',
        quality: 'politique-de-qualite',
      },
      sustainability: {
        framework: 'notre-structure',
        highlights: 'faits-saillants',
        importance: 'pourquoi-cest-important-pour-nous',
        overview: 'sommaire',
        priorities: 'domaines-de-priorites',
      },
    },
    labels: {
      about: {
        community: 'Dans la communauté',
        'directors-board': "Conseil d'administration",
        intro: 'Qui sommes-nous ?',
        'our-purpose': "Notre raison d'être",
        overview: 'Sommaire',
        products: 'Lignes de produits',
      },
      careers: {
        benefits: 'Avantages',
        culture: 'Notre culture',
        intro: 'Qui nous sommes',
        jobs: 'Emplois en haute demande',
        overview: ' sommaire',
        scholarships: "Programmes de bourses d'études CRH Canada",
        values: 'Nos valeurs',
      },
      products: {
        intro: 'Ce que nous faisons ?',
        overview: 'Sommaire',
        products: 'Gamme de produits',
        quality: 'Politique de qualité',
      },
      sustainability: {
        framework: 'Notre structure',
        highlights: 'Faits saillants',
        importance: "Pourquoi c'est important pour nous ?",
        overview: 'Sommaire',
        priorities: 'Domaines de priorités',
      },
    },
  },
  business_unit: "Unité d'affaires",
  company_name: 'Groupe CRH Canada inc.',
  compliance_label: 'Conformité',
  contact_us: 'Contactez-nous',
  credits: ':YEAR © CRH Canada \\| Tous droits réservés',
  filter_by: 'Filtrer par',
  find_a_location: 'Trouver un emplacement',
  gdpr: {
    banner: {
      title: 'Notre utilisation des témoins (cookies)',
      description:
        'Nous utilisons des témoins (cookies) afin d’améliorer votre expérience de navigation et personnaliser le contenu de ce site internet. En cliquant sur Accepter, vous nous permettez d’améliorer la façon dont le site est construit.',
      accept: 'Accepter',
      settings: 'Modifier les préférences',
    },
    settings: {
      title: 'Notre utilisation des témoins (cookies)',
      description:
        "Nous utilisons des témoins (cookies) pour faire fonctionner notre site. Nous utilisons aussi des témoins d'analyse pour nous aider à l'améliorer au fil du temps. Nous ne définirons pas de témoins à moins que vous ne les activiez. L'utilisation de cet outil installera un témoin sur votre appareil pour mémoriser vos préférences. Pour plus d'informations sur les témoins que nous utilisons, consultez notre page Énoncé de confidentialité.",
      essentials: {
        title: 'Témoins essentiels',
        description:
          "Les témoins essentiels activent des fonctionnalités de base telles que la sécurité, la gestion du réseau et l'accessibilité. Vous pouvez les désactiver en modifiant les paramètres de votre navigateur, mais cela peut affecter le fonctionnement du site Web.",
      },
      analytics: {
        title: 'Fichiers de témoins d’analyse',
        description:
          "Nous aimerions définir des fichiers témoins Google Analytics pour nous aider à améliorer notre site Web en collectant et en rapportant des informations sur la façon dont vous l'utilisez. Les fichiers témoins collectent des informations de manière complètement anonyme. Pour plus d'informations sur le fonctionnement de ces fichiers témoins, veuillez consulter notre page Énoncé de confidentialité.",
      },
      save: 'Enregistrer et fermer',
    },
  },
  learn_more: 'Lire plus',
  not_found: {
    label: "Retourner à l'accueil",
    text: {
      bottom:
        "Naviguez le site ou contactez-nous si vous n'arrivez pas à trouver ce dont vous cherchez.",
      top: 'La page que vous cherchez ne semble pas exister',
    },
    title: 'Impossible de trouver la page',
  },
  office: 'Bureau',
  or: 'ou',
  other_sites: 'Autres Sites Web',
  policies: {
    accessibility: 'Accessibilité',
    disclaimer: 'Conditions',
    privacy: 'Confidentialité',
    sms: 'Modalités SMS',
  },
  post: {
    anchor: 'articles',
    latest: {
      legend: 'Dernières nouvelles',
      title:
        "Découvrez les dernières nouvelles de l'écosystème CRH Canada et de ses unités d'affaires",
    },
    mail: {
      body: "Jetez un coup d'oeil à cet article. Cliquez sur le lien ci-dessous :",
      subject: 'Cet article vous est recommandé',
    },
    return: 'Retour au blogue',
    share: 'Partager cette nouvelle',
  },
  product: {
    anchor: 'produits',
  },
  product_type: 'Type de produit',
  search_by_location: 'Chercher par adresse',
  see_more: 'Voir plus',
  seo: {
    fallback: {
      description:
        "CRH est l'une des plus importantes entreprises de matériaux et de construction au Canada.",
      keywords: 'Bâtiment, construction, matériaux, ciment, granulats, asphalte, béton',
      title: 'CRH Canada',
    },
    not_found: {
      title: 'Page introuvable | CRH Canada',
    },
  },
  soil_management: 'Gestion des sols',
}
